module.exports = __webpack_public_path__ + "img/cartoons_anime2.ee124936.jpg";